<script setup lang="ts"></script>

<template>
  <UApp>
    <slot />
  </UApp>
</template>
